import styled from 'styled-components';

const Wrapper = styled.button`
  width: auto;
  padding: 0.8em 0.4em;
  color: ${props => props.theme.main.white};
  background-color: ${props => props.theme.main.primary};
  border: 1px solid ${props => props.theme.main.primary};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;

  &:hover {
    cursor: pointer;
    background-color: linear-gradient(
        0deg,
        rgba(252, 252, 253, 0.2),
        rgba(252, 252, 253, 0.2)
      ),
      #101828;
    box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.12);
    border: 1px solid ${props => props.theme.green.extraDark};
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export default Wrapper;
